import moment from "moment";
import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const partialReturnReship = async (data) => {
  try {
    return await postRequest(urls.PARTIAL_RETURN_RESHIP, data);
  } catch (err) {
    return err;
  }
};
